var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.selectedBot.pagerole || (_vm.selectedBot.pagerole && _vm.selectedBot.pagerole == 'admin'))?_c('div',{staticClass:"template mt-3"},[(!_vm.loading)?[(_vm.themeExist)?[_c(_vm.currentView,{tag:"component"})]:[_c('template-reporter',{tag:"component"})]]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61f735c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/template/Template.vue
// module id = null
// module chunks = 